const ctaForm = document.querySelector('.product-form-wrapper .product-form__buttons-row');
const productInfoContainer = document.querySelector('.product__info-container');
const threshold = ctaForm?.getBoundingClientRect().bottom + window.scrollY;

if (!productInfoContainer || window.innerWidth > 1199) return;

function handleStickyState() {
  const scroll = window.scrollY.toFixed(2);
  if (scroll > threshold) {
    productInfoContainer.classList.add('product__info-container--sticky-cta');
  } else {
    productInfoContainer.classList.remove('product__info-container--sticky-cta');
  }
}

handleStickyState();

window.addEventListener('scroll', handleStickyState);